module.exports = __webpack_public_path__ + "static/media/map_europe.cedee36c.png";